import React from "react";
import { useCreation } from "ahooks";
import { LoadMoreButton } from "../components/LoadMoreButton/LoadMoreButton";
import { Img } from "../ImgV2/Img";
import { VideoPlayIcon } from "../components/VideoPlayIcon/VideoPlayIcon";
import { NewsVideoListBloc } from "./NewsVideoListBloc";
import styles from "./NewsVideoList.module.scss";
export function NewsVideoList(props) {
  var bloc = useCreation(function () {
    return new NewsVideoListBloc();
  }, []);
  bloc.setProps(props);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.newsVideoListWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.scrollView
  }, bloc.videoList.value.map(function (video, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.item,
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.imgBox
    }, /*#__PURE__*/React.createElement(Img, {
      className: "newsVideoListThumbnailImg",
      imgKey: video.news_video.video_thumbnail
    }), /*#__PURE__*/React.createElement(VideoPlayIcon, {
      className: "newsVideoListPlayIcon"
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.videoDetail
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.videoInfo
    }, /*#__PURE__*/React.createElement("p", {
      className: styles.videoHeadLine
    }, video.news_video.video_headline), /*#__PURE__*/React.createElement("p", {
      className: styles.videoDuration
    }, video.news_video.video_duration)), /*#__PURE__*/React.createElement("div", {
      className: styles.videoSource
    }, /*#__PURE__*/React.createElement("img", {
      src: video.news_video.source.source_icon
    }), /*#__PURE__*/React.createElement("span", null, video.news_video.source.source_text))));
  })), bloc.showLoadMore.value && /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement(LoadMoreButton, {
    className: "newsVideoListBtn",
    btnText: "See more",
    loadMore: function loadMore() {
      return bloc.loadMore();
    }
  })));
}